import { render } from "./TraspasoCreate.vue?vue&type=template&id=80ae422a&scoped=true"
import script from "./TraspasoCreate.vue?vue&type=script&lang=js"
export * from "./TraspasoCreate.vue?vue&type=script&lang=js"

import "./TraspasoCreate.vue?vue&type=style&index=0&id=80ae422a&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80ae422a"]])

export default __exports__